import React from 'react';

import { UserGroup } from '../../types/common';
import Chip, { ChipProps } from '../Chip';

export interface StaffGroupChipProps extends ChipProps {
  group: UserGroup;
}

const getColor = (group: UserGroup) => {
  switch (group) {
    case UserGroup.Teachers:
      return 'lightBlue';
    case UserGroup.Admins:
      return 'lightOrange';
    case UserGroup.Managers:
      return 'lightRed';
    case UserGroup.Owners:
      return 'lightRed';
    default:
      return 'lightTurquoise';
  }
};

const StaffGroupChip = ({ group, ...rest }: StaffGroupChipProps) => (
  <Chip
    // Remove plural 's'
    label={group.slice(0, -1)}
    color={getColor(group)}
    {...rest}
  />
);

export default StaffGroupChip;
